<template>
  <div class="baiduQueue">
    <div class="head">
      <img src="/static/index/index1.png" alt="">
      <div class="h0">
        <div class="h1"></div>
        <!-- <div class="h2">
          <div class="h21"><el-input v-model="input" @keyup.enter.native="search" placeholder="输入品牌/型号"></el-input>
          </div>
          <div class="h22" @click="search">查询</div>
        </div> -->
      </div>
    </div>
    <div class="label label2">
      <div class="l1">
        <div :class="item.id == typeId ? 'l11' : ''" v-for="(item, index) in treeList" :key="index"
          @click="updateTree(item)">{{ item.name }}</div>
      </div>
    </div>

    <div class="video-grid">
      <div class="video-card" v-for="(item, index) in treeList_" :key="index" @click="updateTreeChild(item, index)">
        <div class="video-thumbnail">
          <img :src="item.imgUrl" alt="">
          <div class="play-icon">
            <i class="el-icon-video-play"></i>
          </div>
        </div>
        <div class="video-info">
          <div class="video-title">{{ item.name }}</div>
        </div>
      </div>
      <div class="video-card-placeholder" v-for="i in getPlaceholderCount()" :key="'placeholder-' + i"></div>
    </div>

    <footer1></footer1>
    <show ref="show"></show>
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  title: "课程列表",
  data() {
    return {
      input: '', // 搜索产品输入
      state: false,// 是否显示所有产品类型
      instructions: false,//是否显示某个产品型号说明书
      modelIndex: 0,//产品型号 经销商 应用视频 故障视频 公司介绍切换
      typeId: 0,
      treeList: [],
      treeList_: [],
      list: [],
      list2: [],
      list3: [],
      agent: [],
      specList: [],
      dialogVisible: false,
      dialogVisible2: false,
      videoTitle: '',
      src: '',
      price: ''

    };
  },
  computed: {},
  components: {},
  mounted() {
    this.$axios
      .post("/do_web_video_type", this.$qs.stringify({ parent: 1 }))
      .then((res) => {
        console.log(res);
        this.treeList = res.data.data
        this.typeId = res.data.data[0].id
        console.log(this.typeId);
        this.getData(res.data.data[0].id)

      });


  },
  methods: {

    //  产品型号 经销商 应用视频 故障视频 公司介绍切换
    updateTree(e) {
      this.typeId = e.id
      this.getData(e.id)
    },
    updateTreeChild(e, index) {
      this.$router.push({
        path: '/webVideoDetails',
        query: {
          id: e.id,
          typeId: this.typeId
        }
      })
    },

    getData(e) {
      this.$axios
        .post("/do_web_video", this.$qs.stringify({ typeId: e }))
        .then((res) => {
          console.log(res);
          this.treeList_ = res.data.data.rows
        });

    },

    // 添加新方法计算需要的占位符数量
    getPlaceholderCount() {
      // 每行显示4个卡片
      const cardsPerRow = 4;
      // 如果没有数据，不添加占位符
      if (!this.treeList_ || this.treeList_.length === 0) return 0;
      // 计算当前行剩余空间需要的占位符数量
      const remainder = this.treeList_.length % cardsPerRow;
      // 如果正好是cardsPerRow的倍数，不需要占位符
      return remainder === 0 ? 0 : cardsPerRow - remainder;
    }
  },
};
</script>
<style lang="scss" scoped>
.baiduQueue {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  // min-height: 940px;
  // display: flex;
  // flex-direction: column;
  .head {
    width: 100%;
    height: 470px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }

    .h0 {
      width: 1200px;
      z-index: 1;

      .h1 {
        font-size: 46px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #FFFFFF;
        margin-bottom: 58px;
        text-align: center;
      }

      .h2 {
        width: 922px;
        height: 78px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #FFFFFF;
        border-radius: 6px;
        margin: 0 auto;

        .h21 {
          padding-left: 30px;
          width: 80%;

          .el-input {
            width: 80%;
          }

          /deep/ .el-input__inner {
            border: none;

            font-size: 24px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #999999;
          }
        }

        .h22 {
          width: 208px;
          height: 78px;
          background: #FF5602;
          border-radius: 6px;
          text-align: center;
          line-height: 78px;
          font-size: 24px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    }
  }

  .label {
    width: 1200px;
    margin: 50px auto 30px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: 50px;
    overflow: hidden;
    transition: height 1s;

    .l1 {
      display: flex;
      flex-wrap: wrap;

      width: 100%;

      div {
        padding: 0 26px;
        height: 50px;
        background: #FFFFFF;
        border-radius: 33px;
        line-height: 50px;
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
      }

      .l11 {
        background: #198AFA;
        color: #FFFFFF;
      }
    }

    .l2 {
      display: flex;
      align-items: center;
      height: 50px;
      cursor: pointer;

      div {
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        margin-right: 6px;
      }

      img {
        width: 12px;
        height: 8px;
      }
    }
  }

  .label2 {
    height: auto;
    transition: height 1s;
  }

  .video-grid {
    width: 1200px;
    margin: 0 auto 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    background: #FFFFFF;
    padding: 20px;
    min-height: 500px;
  }

  .video-card,
  .video-card-placeholder {
    width: 270px;
    margin: 0 15px 30px;
    flex: 0 0 270px;
    /* 关键修改：固定宽度，不允许伸缩 */
  }

  .video-card {
    cursor: pointer;
    transition: all 0.3s ease;
    background: #f9f9f9;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

      .play-icon {
        opacity: 1;
      }
    }

    .video-thumbnail {
      position: relative;
      width: 100%;
      height: 180px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
      }

      .play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 50px;
        background: rgba(25, 138, 250, 0.8);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.7;
        transition: opacity 0.3s ease;

        i {
          color: white;
          font-size: 24px;
        }
      }
    }

    .video-info {
      padding: 15px;

      .video-title {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        height: 44px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }

  // 占位卡片样式 - 透明不可见
  .video-card-placeholder {
    height: 0;
    padding: 0;
    margin-bottom: 0;
    visibility: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/webVideo/index.vue